/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Cpu(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,144H216V112h16a8,8,0,0,0,0-16H216V56a16.01833,16.01833,0,0,0-16-16H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H56A16.01833,16.01833,0,0,0,40,56V96H24a8,8,0,0,0,0,16H40v32H24a8,8,0,0,0,0,16H40v40a16.01833,16.01833,0,0,0,16,16H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h40a16.01833,16.01833,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-68,12a8.00039,8.00039,0,0,1-8,8H100a8.00039,8.00039,0,0,1-8-8V100a8.00039,8.00039,0,0,1,8-8h56a8.00039,8.00039,0,0,1,8,8Zm-56-48h40v40H108Z" />
    </Svg>
  );
}

export default Cpu;
